const notificationsPage = {
  en: {
    notifications: {
      title: 'Notifications',
      showUnresolvedBtn: 'Show only unresolved',
      tableHeaderNotifications: 'Notifications',
      tableHeaderPatientId: 'Patient ID',
      tableHeaderTime: 'Time',
      markResolveRadio: 'Mark as resolved',
      resolvedRadio: 'Resolved',
      notificaitonResolvedMsg: 'Notification resolved',
      residentMerged: 'Patients successfully merged',
      residentSeparated: 'Patients remain separated',
      notificaitonUnresolvedMsg: 'Notification has not been resolved. Try again later',
      noMoreData: 'No more data',
      viewProfileBtn: 'View profile',
      resolveBtn: 'Resolve',
      viewBtn: 'View',
      errorMsg: 'Something went wrong',
    },
    resolvedDuplicateResident: {
      duplicateTitle: 'might be a duplicate',
      separateTitle: 'are separated',
      prefferedNameField: 'Preferred name',
      dateOfBirthField: 'Date of birth',
      middleNameField: 'Middle name',
      sexField: 'Sex',
      optInField: 'Opt-in',
      contactsField: 'Contacts',
      athenaField: 'Athena (EMR) ID',
      communityField: 'Location ID',
      noContacts: 'No contacts',
      residentTitle: 'Patient',
    },
    duplicateResident: {
      residentMerged: 'Patients successfully merged',
      residentSeparated: 'Patients remain separated',
      notificaitonUnresolvedMsg: 'Something went wrong. Try again later',
      title: '{firstResident} and {secondResident} might be a duplicate',
      subtitle:
        ' Please check if {firstResident} and {secondResident} are the same person. If they are, select which one should remain',
      cancelBtn: 'No, they are different',
      submitBtn: 'Choose this one',
      selectedResidentTitle: 'This one will remain',
      prefferedNameField: 'Preferred name',
      dateOfBirthField: 'Date of birth',
      middleNameField: 'Middle name',
      sexField: 'Sex',
      optInField: 'Opt-in',
      contactsField: 'Contacts',
      athenaField: 'Athena (EMR) ID',
      communityField: 'Location ID',
      noContacts: 'No contacts',
      residentTitle: 'Patient',
    },
    reviewConsent: {
      title: 'Review consent',
      subtitle: 'Consent',
      cancelBtn: 'Cancel',
      submitBtn: 'Update',
      selectStatus: 'Select status:',
      inputLabel: 'Rejected because of',
      inputPlaceholder: 'Please specify why this consent is invalid',
      preview: 'Preview',
      consentInvalidMsg: 'Consent was marked as invalid. Additional notification was created',
      consentResolvedMsg: 'Notification resolved',
      errorMsg: 'Something went wrong. Try again later.',
    },
    reviewInsurance: {
      title: 'Review insurance',
      subtitle: 'Insurane',
      cancelBtn: 'Cancel',
      submitBtn: 'Update',
      new: 'New',
      selectStatus: 'Select status:',
      inputLabel: 'Rejected because of',
      inputPlaceholder: 'Please specify why this consent is invalid',
      insuranceInvalidMsg: 'Insurance was marked as invalid. Additional notification was created',
      insuranceResolvedMsg: 'Notification resolved',
      errorMsg: 'Something went wrong. Try again later.',
    },
  },
}
export default notificationsPage
